import { useNavigate } from "react-router-dom";
import "./CourseCard.css";
import React from "react";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import FlagIcon from "@mui/icons-material/Flag";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClassIcon from "@mui/icons-material/Class";

function CourseCard({
  class_id,
  class_name,
  school,
  course,
  teacher,
  terminated,
}) {
  const navigate = useNavigate();
  return (
    <>
      <div
        key={class_id}
        className="classCard"
        onClick={() => navigate(`/classes/${class_id}`)}
      >
        <div className="classHeader">
          <div className="classIcon">
            <ClassIcon />
          </div>
          <h3 className="classTitle">{class_name}</h3>
          <div
            className={`statusIndicator ${
              terminated ? "inactive" : "active"
            }`}
          >
            {terminated ? <CancelIcon /> : <CheckCircleIcon />}
          </div>
        </div>

        <div className="classContent">
          <div className="classDetails">
            <div className="detailItem">
              <MenuBookIcon className="detailIcon" />
              <span className="detailLabel">Program:</span>
              <span className="detailValue">
                {course || "N/A"}
              </span>
            </div>

            <div className="detailItem">
              <PersonIcon className="detailIcon" />
              <span className="detailLabel">Instructor:</span>
              <span className="detailValue">
                {teacher || "N/A"}
              </span>
            </div>

            <div className="detailItem">
              <SchoolIcon className="detailIcon" />
              <span className="detailLabel">School:</span>
              <span className="detailValue">{school || "N/A"}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CourseCard;
